class AcceptedDocumentTypeManager {
  constructor({
    mimeTypes = ['application/pdf', 'image/jpeg', 'image/png'],
    extensions = ['.pdf', '.jpg', '.jpeg', '.png']
  } = {}) {
    this.mimeTypes = mimeTypes;
    this.extensions = extensions;
  }

  dropzoneAccept() {
    return [...this.mimeTypes, ...this.extensions].join(',');
  }

  hintText() {
    return 'Încarcă fișier PDF, JPG sau PNG';
  }

  isAccepted(file) {
    if (!file || !file.name) {
      return false;
    }

    const fileName = String(file.name).toLowerCase();
    return this.extensions.some(extension => fileName.endsWith(extension));
  }
}

export default AcceptedDocumentTypeManager;
